import React from 'react';
// import sections
import PrivacyContent from '../components/sections/PrivacyContent';

const Privacy = () => {
  return (
    <>
      <PrivacyContent />
    </>
  );
};

export default Privacy;
